<template>
  <AppToastCard variant="dark" data-locator="document-viewer-redact-ai-progress">
    <div class="d-flex align-center">
      <v-progress-circular
        v-if="!finished"
        data-locator="document-viewer-redact-ai-progress-loading-icon"
        indeterminate
        width="2"
        size="16"
      />
      <app-material-icon
        v-else
        data-locator="document-viewer-redact-ai-progress-finished-icon"
        name="check_circle"
        color="white"
        size="sm"
      />
      <p class="ml-2 my-0 text--bold">
        {{
          finished
            ? $t('common.DocumentViewer.DocumentViewerRedactAiProgress.redactAiFinished')
            : $t('common.DocumentViewer.DocumentViewerRedactAiProgress.redactAiProcessing')
        }}
      </p>
  </div>
  </AppToastCard>
</template>

<script setup lang="ts">
import { onBeforeUnmount, watchEffect } from 'vue'

import AppToastCard from '@/common/AppToastCard.vue'

const props = withDefaults(defineProps<{
  finished: boolean
  durationMs?: number
}>(), {
  durationMs: 5000,
})

type Emits = (e: 'close') => void
const emit = defineEmits<Emits>()

let timer: ReturnType<typeof globalThis.setTimeout> | null = null

watchEffect(() => {
  if (props.finished) {
    timer = globalThis.setTimeout(() => {
      emit('close')
      }, props.durationMs)
    }
  },
)

function clearTimer () {
  if (timer !== null) {
    globalThis.clearTimeout(timer)
    timer = null
  }
}
  
onBeforeUnmount(() => {
  clearTimer()
})

</script>
